require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i.json") })
        }
      }, "path---en-eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i!./.cache/json/en-eventi-guida-storico-critica-allarchitettura-del-xx-secolo-nel-cantone-ticino-vol-i.json
// module id = 565
// module chunks = 231608221292675